import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Microbiologia/addMicrobiologia`, method: 'POST', body: values, token: token})
}